import { useLayoutEffect, useRef } from "react";
import { usePageLoader } from "../contexts/page_content_context";

/**
 * usePageStartBootstrap
 */

export const usePageStartBootstrap = (callback: () => (Promise<void> | void)) => {
  const handlerRef = useRef(false);
  const loader = usePageLoader();

  useLayoutEffect(() => {
    if (!handlerRef.current) {
      loader.setPageLoading(true);

      requestAnimationFrame(async () => {
        try {
          await callback();
        } finally {

          requestAnimationFrame(() => {
            const el = document.querySelector('.size-full.pb-\\[4rem\\].absolute.x-0.y-0.overflow-auto');
            if (el) {
              el.scrollTop = 0;
            }
            requestAnimationFrame(() => {
              loader.setPageLoading(false);
            });
          });
        }
      });

      handlerRef.current = true;
    }
  }, [
    loader,
    callback,
  ]);
}